export default "__VITE_ASSET__DzwwxVUS__"